module.exports = __webpack_public_path__ + "img/blt-btn02.1a12288f.svg";